import { render, staticRenderFns } from "./ExamDetails.vue?vue&type=template&id=4740c5c0&scoped=true"
import script from "./ExamDetails.vue?vue&type=script&lang=js"
export * from "./ExamDetails.vue?vue&type=script&lang=js"
import style0 from "./ExamDetails.vue?vue&type=style&index=0&id=4740c5c0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4740c5c0",
  null
  
)

export default component.exports